import { Apple } from 'lucide-react';

// Flags a delivery carrying freefood orders. `size` (px) lets dense views (tour stop rows) render a smaller icon.
export const FreefoodIcon = ({ size = 16 }: { size?: number }): JSX.Element => (
    <span className="inline-flex" title="Freefood">
        <Apple size={size} className="shrink-0" />
    </span>
);
